import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["floating", "submitButton", "currentTab", "tab"]

  connect() {
    this.submitting = false
    this.beforeUnloadHandler = this.beforeUnload.bind(this)
    this.beforeVisitHandler = this.beforeVisit.bind(this)

    this.initialState = this.serializeState()

    window.addEventListener("beforeunload", this.beforeUnloadHandler)
    document.addEventListener("turbolinks:before-visit", this.beforeVisitHandler)

    requestAnimationFrame(() => this.activateSavedTab())
    this.refresh()
  }

  disconnect() {
    window.removeEventListener("beforeunload", this.beforeUnloadHandler)
    document.removeEventListener("turbolinks:before-visit", this.beforeVisitHandler)
  }

  refresh() {
    const currentState = this.serializeState()
    const dirtyKeys = Object.keys(currentState).filter((key) => currentState[key] !== this.initialState[key])
    const isDirty = dirtyKeys.length > 0

    if (this.hasFloatingTarget) {
      this.floatingTarget.classList.toggle("hidden", !isDirty)
    }

    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = !isDirty
    }

    this.isDirty = isDirty
  }

  submit() {
    this.submitting = true
  }

  rememberTab(event) {
    if (!this.hasCurrentTabTarget) return

    this.currentTabTarget.value = event.currentTarget.dataset.tabId || ""
  }

  submitAfterAction() {
    setTimeout(() => {
      this.element.requestSubmit()
    }, 0)
  }

  beforeUnload(event) {
    if (!this.isDirty || this.submitting) return

    event.preventDefault()
    event.returnValue = ""
  }

  beforeVisit(event) {
    if (!this.isDirty || this.submitting) return

    if (!window.confirm("Vous avez des modifications non enregistrées. Voulez-vous vraiment quitter cette page ?")) {
      event.preventDefault()
    }
  }

  serializeState() {
    const state = {}
    const radioNames = new Set()

    this.element.querySelectorAll("input, select, textarea").forEach((field) => {
      if (!field.name || ["utf8", "_method", "authenticity_token", "commit"].includes(field.name)) return
      if (field.dataset.settingsFormIgnoreDirty === "true") return

      if (field.type === "radio") {
        if (radioNames.has(field.name)) return
        radioNames.add(field.name)

        const checked = this.element.querySelector(`input[type="radio"][name="${CSS.escape(field.name)}"]:checked`)
        state[field.name] = checked ? checked.value : ""
        return
      }

      if (field.type === "file") {
        state[field.name] = Array.from(field.files || []).map((file) => `${file.name}:${file.size}:${file.lastModified}`).join("|")
        return
      }

      if (field.type === "checkbox") {
        state[field.name] = field.checked ? "1" : "0"
        return
      }

      state[field.name] = field.value
    })

    return state
  }

  activateSavedTab() {
    if (!this.hasCurrentTabTarget || !this.currentTabTarget.value) return

    const targetTab = this.tabTargets.find((tab) => tab.dataset.tabId === this.currentTabTarget.value)
    if (targetTab) targetTab.click()
  }
}
